// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 10\"><path d=\"M0 5 C 20 0, 40 10, 60 5 S 100 0, 100 5\" stroke=\"rgb%28124, 34, 186%29\" stroke-width=\"2\" fill=\"none\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.hero-section {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hero-heading {
  color: #000;
  margin-top: 0;
  margin-bottom: 0;
  padding-bottom: 20px;
  font-family: Plus Jakarta Sans, sans-serif;
  font-size: 50px;
  line-height: 45px;
  display: block;
  position: relative;
  font-weight: 800;
}

.made-simple-text {
  color: #7c22ba;
}

.with-text {
  color: #000;
  margin-top: 4px;
  font-size: 20px;
  font-weight: 700;
  line-height: 140%;
  position: relative;
  top: -17px;
}

.hero-section-para {
  color: #404040;
  padding-top: 0;
  font-size: 20px;
}

.hero-section-para span {
  color: #090909;
  font-weight: 800;
}

.hero-section-text {
  width: 50%;
}

.border-gradient {
  position: relative;
  display: inline-block;
  margin: 2.5rem 0;
}

.border-gradient div {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.border-gradient-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: auto;
  font-size: 20px;
  line-height: 100%;
}

.border-gradient-text span {
  color: black;
}

.border-gradient:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  width: 130%;
  height: 2px;
  background: linear-gradient(to right, transparent, #d2d2d2, transparent);
  transform: translateX(-50%);
}

.border-gradient:before {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  width: 130%;
  height: 3px;
  background: linear-gradient(to right, transparent, #d2d2d2, transparent);
  transform: translateX(-50%);
}

.book-button {
  width: 70%;
  background: #7c22ba;
  font-size: x-large;
  font-weight: 700;
  color: white;
  padding: 0.7rem 0;
  border: none;
  border-radius: 2.5rem;
}

.sold-out {
  margin-top: 1.5rem;
  width: 80%;
  text-align: center;
}

.progress-bar {
  width: 100%;
  height: 20px;
  background-color: #e0e0e0 !important;
  border-radius: 10px;
  padding: 0 !important;
  position: relative;
}

.progress {
  position: absolute;
  z-index: 100;
  left: 0;
  height: 100% !important;
  top: 0;
  width: 84.7%;
  background-color: #7c22ba !important;
  border-radius: 10px;
}

.percentage-label {
  text-align: center;
  margin-top: 6px !important;
  font-weight: 600;
}

.percentage-label span {
  color: black;
  font-weight: 800;
}

.hero-image-wrapper {
  width: 100%;
}

.hero-image-wrapper img {
  object-fit: cover;
  width: 100%;
}

.numbers-section {
  width: 100vw;
  background-color: #ebf1ff;
  height: 15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10rem 0;
  padding-bottom: 12rem;
}

.numbers-section-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.numbers-section-content h2 {
  width: 30%;
  font-weight: bold;
  font-size: 40px;
}

.numbers-section-card-container {
  display: flex;
  gap: 1rem;
}

.numbers-section-card {
  background-color: white;
  border-radius: 10px;
  padding: 0.5rem;
  width: 11rem;
  height: 14rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.numbers-section-card img {
  height: 80%;
  width: 80%;
  object-fit: cover;
  overflow: hidden;
  margin-bottom: 0.7rem;
}

.numbers-section-card div {
  width: 87%;
  text-align: center;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.numbers-section-card h4 {
  color: #7c22ba;
  font-weight: 800 !important;
  margin: 0;
  margin-bottom: 0.2rem;
  text-align: center;
}

.numbers-section-card p {
  margin: 0 auto;
  color: black;
  font-weight: 700;
  font-size: larger;
  line-height: 20px;
  letter-spacing: -0.5px;
  text-align: center;
  margin: 0 !important;
}

.reviews-section {
  margin-top: 1rem;
  width: 75%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.reviews-section h1 {
  font-weight: 700;
}

.hand-drawn-line {
  width: 100%;
  height: 1.5rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat center;
  background-size: contain;
}

.reviews {
  width: 100%;
}

.reviews-slider {
  padding-top: 10px;
  width: 115%;
  margin: auto;
  text-align: center;
}

.reviews-slider .slick-slider .slick-arrow {
  opacity: 0 !important;
}

.reviews-slider .slick-dots {
  bottom: -20px;
  right: 50px;
}

.slick-dots li button:before {
  font-size: 10px;
}

.review-slider {
  max-width: 100%;
  width: 100%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.review {
  margin: 10px 0;
  width: 45%;
  border-radius: 10px;
  flex-direction: column-reverse;
  justify-content: space-between;
  padding: 15px 22px;
  display: flex;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
}

.review-heading {
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 32px;
  margin-bottom: 0;
  display: flex;
}

.review-heading-left {
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  align-items: center;
  display: flex;
}

.review-heading-left img {
  border-radius: 50%;
  object-fit: contain;
  width: 66px;
  height: 66px;
}

.review-heading-left-content {
  width: 100%;
}

.review-heading-left-content h3 {
  margin-top: 0;
  margin-bottom: 0;
  font-family: Poppins, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 100%;
}

.review-heading-left-content p {
  color: #999;
  margin-bottom: 0;
  font-family: Poppins, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
}

.review-heading-right {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.review-heading-right span {
  color: #000;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 2px;
  font-family: Poppins, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 100%;
}

.review-paragraph {
  text-align: left;
  color: #404040;
  letter-spacing: -0.5px;
  margin-bottom: 0;
  font-size: 16px;
  line-height: 160%;
}

.potential-section {
  width: 90%;
  padding: 76px 0px;
}

.section-heading-2 {
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  left: auto;
  right: auto;
}

.section-heading-text {
  color: #090909;
  border: 1px #000;
  margin-top: 0;
  font-family: Poppins, sans-serif;
  font-size: 38px;
  line-height: 44.5px;
  font-weight: 700;
}

.section-heading-pr-2 {
  color: gray;
  font-size: 20px;
  font-weight: 600;
}

.money-grid {
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  margin-top: 60px;
  display: grid;
}

.money-grid-item {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  align-items: flex-start;
  padding: 24px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  border: 2px solid #ebf1ff;
  border-radius: 10px;
  display: flex;
}

.money-grid-item-img-wrapper {
  width: 67px;
  height: 54px;
}

.money-grid-item-content {
  width: 100%;
}

.money-grid-item-heading {
  margin-top: 0;
  margin-bottom: 8px;
  font-family: Inter, sans-serif;
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
}

.money-grid-item-paragraph {
  margin-bottom: 10px;
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}

.learn-section {
  padding-bottom: 76px;
  width: 75%;
  text-align: center;
}

.learn-heading_wrapper {
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  padding-top: 0;
  display: flex;
  position: relative;
  text-align: center;
}

.learn-heading_wrapper h2 {
  margin-top: 0;
  font-family: Plus Jakarta Sans, sans-serif;
  color: #090909;
  text-align: center;
  background-clip: text;
  max-width: 365px;
  font-size: 40px;
  line-height: 50px;
  font-weight: 800;
}

.learn-card-wrapper {
  grid-column-gap: 56px;
  grid-row-gap: 56px;
  flex-direction: column;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
}

.learning_card {
  display: flex;
  gap: 6rem;
  align-items: center;
}

.reversed {
  flex-direction: row-reverse;
}

.learning_card-image-wrapper {
  align-self: flex-start;
  border-radius: 10px;
  width: 375px;
  height: 238px;
}

.learning_card-image {
  vertical-align: middle;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: inline-block;
}

.learning_card-content-wrapper {
  text-align: left;
  align-self: flex-start;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  cursor: default;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  width: 492px;
  max-width: 100%;
  height: 239px;
  padding: 36px 28px;
  transition: all 0.4s;
  display: flex;
}

.learning_card-content {
  width: 100%;
  max-width: 100%;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  display: flex;
}

.time_text {
  color: rgba(9, 9, 9, 0.5);
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.learning_card-heading {
  color: #1e1e1e;
  margin-top: 0;
  margin-bottom: 0;
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  max-width: 100%;
  height: auto;
}

.learning_card-para {
  color: #282828;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
}

.masterclass-for-section {
  padding-bottom: 76px;
  width: 90%;
  text-align: center;
  margin: 0 auto;
}

.masterclass-for-grid {
  width: 100%;
  margin: 0 auto;
  display: flex;
  gap: 1.1rem;
}

.who_card {
  color: #404040;
  border: 1px solid #ebf1ff;
  border-radius: 10px;
  align-items: flex-start;
  padding: 24px 16px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  grid-column-gap: 11px;
  grid-row-gap: 11px;
  display: flex;
}

.who-card_html_embedded {
  justify-content: center;
  align-self: flex-start;
  align-items: flex-start;
  display: flex;
}

.who-card_html_embedded h3 {
  font-size: 30px;
}

.who_card-point {
  grid-column-gap: 11px;
  grid-row-gap: 11px;
  flex-direction: column;
  display: flex;
  text-align: left;
}

.point_heading {
  color: #090909;
  margin-top: 0;
  margin-bottom: 0;
  font-family: Plus Jakarta Sans, sans-serif;
  font-size: 22px;
  line-height: 26px;
  font-weight: 700;
}

.point_para {
  color: #404040;
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
}

.featured-on-section {
  width: 100vw;
  background-color: #ebf1ff;
  height: 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
}

.featured-on-container {
  overflow: hidden;
  width: 80%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.featured-on-container > div {
  height: 85% !important;
}

.featured_on_img {
  margin-right: 4rem;
  width: 7rem;
}

.featured_on_img img {
  width: 100% !important;
  object-fit: cover;
}

.faq-section {
  width: 80%;
  text-align: center;
  padding-bottom: 30px;
}

.faq-list {
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  flex-flow: column;
  display: flex;
  transition: height 0.5s ease;
}

.faq-list-item {
  border-radius: 10px;
  background-color: #ebf1ff;
  text-align: left;
  max-height: 6rem;
  overflow: hidden;
  transition: max-height 0.5s ease;
}

.faq-list-item-height {
  max-height: 15rem !important;
  transition: max-height 0.5s ease;
}

.faq-question-wrapper {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  padding: 32px 46px 20px;
  display: flex;
}

.faq-question-wrapper h3 {
  color: #000;
  flex: 1 1;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 0;
  font-family: Poppins, sans-serif;
  font-size: 22px;
  font-weight: 500;
  line-height: 33px;
}

.faq-question-wrapper .cross_icon {
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
    rotateY(0deg) rotateZ(45deg) skew(0deg, 0deg);
  transform-style: preserve-3d;
  transition: all 0.5s;
}

.faq-question-wrapper .plus_icon {
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)
    rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
  transform-style: preserve-3d;
  transition: all 0.5s;
}

.faq-list-item-answer {
  opacity: 1;
  color: #464646;
  margin-top: 0;
  padding: 4px 46px 24px;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 300;
  line-height: 33px;
}

@media screen and (max-width: 475px) {
  .hero-section {
    flex-direction: column;
    text-align: center;
  }

  .hero-section-text {
    width: 100%;
  }

  .hero-heading {
    white-space: normal;
    font-size: 30px !important;
    line-height: 60%;
  }

  .with-text {
    margin-top: 15px;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 155%;
  }

  .hero-section-para {
    font-size: 18px;
    line-height: 155%;
  }

  .book-button {
    letter-spacing: 0;
    width: 80%;
    font-family: Inter, sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 30px;
  }

  .sold-out {
    margin-top: 1.5rem;
    width: 100%;
    text-align: center;
  }

  .percentage-label {
    font-size: 18px;
  }

  .percentage-label span {
    color: black;
    font-weight: 800;
  }

  .border-gradient:after {
    left: 10%;
    display: none;
    width: 160%;
  }

  .border-gradient:before {
    left: 10%;
    display: none;
    width: 160%;
  }

  .border-gradient-text {
    font-size: 16px;
    line-height: 100%;
  }

  .numbers-section {
    height: auto;
    padding-top: 5rem;
    padding-bottom: 6rem;
    padding-right: 2rem;
    padding-left: 2rem;
  }

  .numbers-section-content h2 {
    width: 80%;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 10px;
  }

  .numbers-section-content {
    flex-direction: column;
  }

  .numbers-section-card-container {
    display: grid;
    grid-template-columns: 1fr 120px;
    grid-template-rows: 1fr 0.5fr;
  }

  .numbers-section-card {
    width: auto;
  }

  .numbers-section-card h4 {
    font-weight: 800 !important;
    font-size: medium;
    width: 100%;
  }

  .numbers-section-card p {
    font-weight: 700;
    font-size: small;
  }

  .reviews-section {
    text-align: center;
  }

  .review {
    width: 100%;
  }

  .slick-dots {
    right: 0 !important;
    bottom: -50px !important;
  }

  .slick-dots li {
    margin: 0 2px;
  }

  .section-heading-pr-2 {
    font-size: 18px;
  }

  .section-heading-text {
    line-height: 40px;
    font-size: 32px;
  }

  .money-grid {
    grid-template-rows: auto;
    grid-template-columns: 1fr;
  }

  .masterclass-for-grid {
    flex-direction: column;
  }

  .learning_card {
    flex-direction: column;
    gap: 56px;
  }

  .learn-card-wrapper {
    grid-column-gap: 0px;
    grid-row-gap: 56px;
  }

  .learning_card-image-wrapper {
    width: 100%;
    height: 100%;
  }

  .learning_card-content-wrapper {
    width: 100%;
    max-width: 300px;
    height: 100%;
  }

  .learning_card-heading {
    font-size: 15px;
    line-height: 20px;
  }

  .featured-on-container {
    width: 100%;
  }

  .featured_on_img {
    margin-right: 2rem;
    width: 5rem;
  }

  .faq-list-item {
    border-radius: 10px;
    background-color: #ebf1ff;
    text-align: left;
    max-height: 6rem;
    overflow: hidden;
    transition: max-height 0.5s ease;
  }

  .faq-list-item-height {
    max-height: 30rem !important;
    transition: max-height 0.5s ease;
  }

  .faq-question-wrapper {
    grid-column-gap: 0;
    grid-row-gap: 0;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 32px !important;
    padding: 16px 20px 10px;
    display: flex;
  }

  .faq-question-wrapper h3 {
    flex: 0 1 100%;
    margin-bottom: 8px;
    margin-left: 0;
    padding-right: 20px;
    padding-bottom: 20px;
    font-family: Poppins, sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 160%;
  }

  .faq-list-item-answer {
    padding: 0 20px;
    font-size: 14px;
    line-height: 120%;
  }

  .masterclass_payment_container {
    margin-top: 3rem;
  }
}

/* Masterclass Payment */

.payment_heading {
  text-align: center;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-bottom: 1rem;
}

.go_back {
  position: absolute;
  left: 3%;
  top: 0%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  outline: none;
  border: none;
  cursor: pointer;
  background: none;
}

.go_back p {
  margin-bottom: 3px !important;
}

.price_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.price_wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price_wrapper span {
  font-weight: 400 !important;
  color: black !important;
}

.price_wrapper:nth-child(3) {
  margin-top: 1rem;
  border-top: #000 solid 1px;
  padding-top: 0.5rem;
}

.price_wrapper:nth-child(3) span {
  font-weight: 700 !important;
}

@media screen and (max-width: 475px) {
  .go_back {
    top: -6%;
    left: 1%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Common/Masterclass/masterclass.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,WAAW;EACX,wEAAwE;EACxE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,WAAW;EACX,wEAAwE;EACxE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,uBAAuB;EACvB,MAAM;EACN,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd;oBACkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,gDAAgD;EAChD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gDAAgD;EAChD,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;iDAC+C;EAC/C,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE;gDAC8C;EAC9C,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,WAAW;EACb;;EAEA;IACE,SAAS;IACT,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,6BAA6B;EAC/B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,+BAA+B;IAC/B,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,cAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,QAAQ;IACR,QAAQ;EACV;AACF","sourcesContent":[".container {\n  width: 100%;\n  margin-top: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.hero-section {\n  width: 90%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.hero-heading {\n  color: #000;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-bottom: 20px;\n  font-family: Plus Jakarta Sans, sans-serif;\n  font-size: 50px;\n  line-height: 45px;\n  display: block;\n  position: relative;\n  font-weight: 800;\n}\n\n.made-simple-text {\n  color: #7c22ba;\n}\n\n.with-text {\n  color: #000;\n  margin-top: 4px;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 140%;\n  position: relative;\n  top: -17px;\n}\n\n.hero-section-para {\n  color: #404040;\n  padding-top: 0;\n  font-size: 20px;\n}\n\n.hero-section-para span {\n  color: #090909;\n  font-weight: 800;\n}\n\n.hero-section-text {\n  width: 50%;\n}\n\n.border-gradient {\n  position: relative;\n  display: inline-block;\n  margin: 2.5rem 0;\n}\n\n.border-gradient div {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.border-gradient-text {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: auto;\n  font-size: 20px;\n  line-height: 100%;\n}\n\n.border-gradient-text span {\n  color: black;\n}\n\n.border-gradient:after {\n  content: \"\";\n  position: absolute;\n  top: -20px;\n  left: 50%;\n  width: 130%;\n  height: 2px;\n  background: linear-gradient(to right, transparent, #d2d2d2, transparent);\n  transform: translateX(-50%);\n}\n\n.border-gradient:before {\n  content: \"\";\n  position: absolute;\n  bottom: -5px;\n  left: 50%;\n  width: 130%;\n  height: 3px;\n  background: linear-gradient(to right, transparent, #d2d2d2, transparent);\n  transform: translateX(-50%);\n}\n\n.book-button {\n  width: 70%;\n  background: #7c22ba;\n  font-size: x-large;\n  font-weight: 700;\n  color: white;\n  padding: 0.7rem 0;\n  border: none;\n  border-radius: 2.5rem;\n}\n\n.sold-out {\n  margin-top: 1.5rem;\n  width: 80%;\n  text-align: center;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 20px;\n  background-color: #e0e0e0 !important;\n  border-radius: 10px;\n  padding: 0 !important;\n  position: relative;\n}\n\n.progress {\n  position: absolute;\n  z-index: 100;\n  left: 0;\n  height: 100% !important;\n  top: 0;\n  width: 84.7%;\n  background-color: #7c22ba !important;\n  border-radius: 10px;\n}\n\n.percentage-label {\n  text-align: center;\n  margin-top: 6px !important;\n  font-weight: 600;\n}\n\n.percentage-label span {\n  color: black;\n  font-weight: 800;\n}\n\n.hero-image-wrapper {\n  width: 100%;\n}\n\n.hero-image-wrapper img {\n  object-fit: cover;\n  width: 100%;\n}\n\n.numbers-section {\n  width: 100vw;\n  background-color: #ebf1ff;\n  height: 15rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10rem 0;\n  padding-bottom: 12rem;\n}\n\n.numbers-section-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.numbers-section-content h2 {\n  width: 30%;\n  font-weight: bold;\n  font-size: 40px;\n}\n\n.numbers-section-card-container {\n  display: flex;\n  gap: 1rem;\n}\n\n.numbers-section-card {\n  background-color: white;\n  border-radius: 10px;\n  padding: 0.5rem;\n  width: 11rem;\n  height: 14rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.numbers-section-card img {\n  height: 80%;\n  width: 80%;\n  object-fit: cover;\n  overflow: hidden;\n  margin-bottom: 0.7rem;\n}\n\n.numbers-section-card div {\n  width: 87%;\n  text-align: center;\n  margin: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.numbers-section-card h4 {\n  color: #7c22ba;\n  font-weight: 800 !important;\n  margin: 0;\n  margin-bottom: 0.2rem;\n  text-align: center;\n}\n\n.numbers-section-card p {\n  margin: 0 auto;\n  color: black;\n  font-weight: 700;\n  font-size: larger;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n  text-align: center;\n  margin: 0 !important;\n}\n\n.reviews-section {\n  margin-top: 1rem;\n  width: 75%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.reviews-section h1 {\n  font-weight: 700;\n}\n\n.hand-drawn-line {\n  width: 100%;\n  height: 1.5rem;\n  background: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 10\"><path d=\"M0 5 C 20 0, 40 10, 60 5 S 100 0, 100 5\" stroke=\"rgb(124, 34, 186)\" stroke-width=\"2\" fill=\"none\"/></svg>')\n    no-repeat center;\n  background-size: contain;\n}\n\n.reviews {\n  width: 100%;\n}\n\n.reviews-slider {\n  padding-top: 10px;\n  width: 115%;\n  margin: auto;\n  text-align: center;\n}\n\n.reviews-slider .slick-slider .slick-arrow {\n  opacity: 0 !important;\n}\n\n.reviews-slider .slick-dots {\n  bottom: -20px;\n  right: 50px;\n}\n\n.slick-dots li button:before {\n  font-size: 10px;\n}\n\n.review-slider {\n  max-width: 100%;\n  width: 100%;\n  margin: auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n}\n\n.review {\n  margin: 10px 0;\n  width: 45%;\n  border-radius: 10px;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  padding: 15px 22px;\n  display: flex;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);\n}\n\n.review-heading {\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-top: 32px;\n  margin-bottom: 0;\n  display: flex;\n}\n\n.review-heading-left {\n  grid-column-gap: 15px;\n  grid-row-gap: 15px;\n  align-items: center;\n  display: flex;\n}\n\n.review-heading-left img {\n  border-radius: 50%;\n  object-fit: contain;\n  width: 66px;\n  height: 66px;\n}\n\n.review-heading-left-content {\n  width: 100%;\n}\n\n.review-heading-left-content h3 {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: Poppins, sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 100%;\n}\n\n.review-heading-left-content p {\n  color: #999;\n  margin-bottom: 0;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 160%;\n}\n\n.review-heading-right {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.review-heading-right span {\n  color: #000;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: 2px;\n  font-family: Poppins, sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 100%;\n}\n\n.review-paragraph {\n  text-align: left;\n  color: #404040;\n  letter-spacing: -0.5px;\n  margin-bottom: 0;\n  font-size: 16px;\n  line-height: 160%;\n}\n\n.potential-section {\n  width: 90%;\n  padding: 76px 0px;\n}\n\n.section-heading-2 {\n  text-align: center;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  position: relative;\n  left: auto;\n  right: auto;\n}\n\n.section-heading-text {\n  color: #090909;\n  border: 1px #000;\n  margin-top: 0;\n  font-family: Poppins, sans-serif;\n  font-size: 38px;\n  line-height: 44.5px;\n  font-weight: 700;\n}\n\n.section-heading-pr-2 {\n  color: gray;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.money-grid {\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n  grid-template-rows: auto auto;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-columns: 1fr;\n  margin-top: 60px;\n  display: grid;\n}\n\n.money-grid-item {\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n  align-items: flex-start;\n  padding: 24px;\n  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);\n  border: 2px solid #ebf1ff;\n  border-radius: 10px;\n  display: flex;\n}\n\n.money-grid-item-img-wrapper {\n  width: 67px;\n  height: 54px;\n}\n\n.money-grid-item-content {\n  width: 100%;\n}\n\n.money-grid-item-heading {\n  margin-top: 0;\n  margin-bottom: 8px;\n  font-family: Inter, sans-serif;\n  font-size: 24px;\n  line-height: 24px;\n  font-weight: 700;\n}\n\n.money-grid-item-paragraph {\n  margin-bottom: 10px;\n  font-family: Inter, sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 150%;\n}\n\n.learn-section {\n  padding-bottom: 76px;\n  width: 75%;\n  text-align: center;\n}\n\n.learn-heading_wrapper {\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 50px;\n  padding-top: 0;\n  display: flex;\n  position: relative;\n  text-align: center;\n}\n\n.learn-heading_wrapper h2 {\n  margin-top: 0;\n  font-family: Plus Jakarta Sans, sans-serif;\n  color: #090909;\n  text-align: center;\n  background-clip: text;\n  max-width: 365px;\n  font-size: 40px;\n  line-height: 50px;\n  font-weight: 800;\n}\n\n.learn-card-wrapper {\n  grid-column-gap: 56px;\n  grid-row-gap: 56px;\n  flex-direction: column;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n}\n\n.learning_card {\n  display: flex;\n  gap: 6rem;\n  align-items: center;\n}\n\n.reversed {\n  flex-direction: row-reverse;\n}\n\n.learning_card-image-wrapper {\n  align-self: flex-start;\n  border-radius: 10px;\n  width: 375px;\n  height: 238px;\n}\n\n.learning_card-image {\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: inline-block;\n}\n\n.learning_card-content-wrapper {\n  text-align: left;\n  align-self: flex-start;\n  grid-column-gap: 15px;\n  grid-row-gap: 15px;\n  cursor: default;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n  width: 492px;\n  max-width: 100%;\n  height: 239px;\n  padding: 36px 28px;\n  transition: all 0.4s;\n  display: flex;\n}\n\n.learning_card-content {\n  width: 100%;\n  max-width: 100%;\n  grid-column-gap: 8px;\n  grid-row-gap: 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  display: flex;\n}\n\n.time_text {\n  color: rgba(9, 9, 9, 0.5);\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.learning_card-heading {\n  color: #1e1e1e;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: Inter, sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 30px;\n  max-width: 100%;\n  height: auto;\n}\n\n.learning_card-para {\n  color: #282828;\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 25px;\n}\n\n.masterclass-for-section {\n  padding-bottom: 76px;\n  width: 90%;\n  text-align: center;\n  margin: 0 auto;\n}\n\n.masterclass-for-grid {\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  gap: 1.1rem;\n}\n\n.who_card {\n  color: #404040;\n  border: 1px solid #ebf1ff;\n  border-radius: 10px;\n  align-items: flex-start;\n  padding: 24px 16px;\n  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);\n  grid-column-gap: 11px;\n  grid-row-gap: 11px;\n  display: flex;\n}\n\n.who-card_html_embedded {\n  justify-content: center;\n  align-self: flex-start;\n  align-items: flex-start;\n  display: flex;\n}\n\n.who-card_html_embedded h3 {\n  font-size: 30px;\n}\n\n.who_card-point {\n  grid-column-gap: 11px;\n  grid-row-gap: 11px;\n  flex-direction: column;\n  display: flex;\n  text-align: left;\n}\n\n.point_heading {\n  color: #090909;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: Plus Jakarta Sans, sans-serif;\n  font-size: 22px;\n  line-height: 26px;\n  font-weight: 700;\n}\n\n.point_para {\n  color: #404040;\n  font-family: Inter, sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 26px;\n}\n\n.featured-on-section {\n  width: 100vw;\n  background-color: #ebf1ff;\n  height: 10rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 0;\n}\n\n.featured-on-container {\n  overflow: hidden;\n  width: 80%;\n  margin: 0 auto;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.featured-on-container > div {\n  height: 85% !important;\n}\n\n.featured_on_img {\n  margin-right: 4rem;\n  width: 7rem;\n}\n\n.featured_on_img img {\n  width: 100% !important;\n  object-fit: cover;\n}\n\n.faq-section {\n  width: 80%;\n  text-align: center;\n  padding-bottom: 30px;\n}\n\n.faq-list {\n  grid-column-gap: 24px;\n  grid-row-gap: 24px;\n  flex-flow: column;\n  display: flex;\n  transition: height 0.5s ease;\n}\n\n.faq-list-item {\n  border-radius: 10px;\n  background-color: #ebf1ff;\n  text-align: left;\n  max-height: 6rem;\n  overflow: hidden;\n  transition: max-height 0.5s ease;\n}\n\n.faq-list-item-height {\n  max-height: 15rem !important;\n  transition: max-height 0.5s ease;\n}\n\n.faq-question-wrapper {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  cursor: pointer;\n  justify-content: space-between;\n  align-items: center;\n  padding: 32px 46px 20px;\n  display: flex;\n}\n\n.faq-question-wrapper h3 {\n  color: #000;\n  flex: 1;\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-left: 0;\n  font-family: Poppins, sans-serif;\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 33px;\n}\n\n.faq-question-wrapper .cross_icon {\n  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)\n    rotateY(0deg) rotateZ(45deg) skew(0deg, 0deg);\n  transform-style: preserve-3d;\n  transition: all 0.5s;\n}\n\n.faq-question-wrapper .plus_icon {\n  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg)\n    rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);\n  transform-style: preserve-3d;\n  transition: all 0.5s;\n}\n\n.faq-list-item-answer {\n  opacity: 1;\n  color: #464646;\n  margin-top: 0;\n  padding: 4px 46px 24px;\n  font-family: Inter, sans-serif;\n  font-size: 20px;\n  font-weight: 300;\n  line-height: 33px;\n}\n\n@media screen and (max-width: 475px) {\n  .hero-section {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .hero-section-text {\n    width: 100%;\n  }\n\n  .hero-heading {\n    white-space: normal;\n    font-size: 30px !important;\n    line-height: 60%;\n  }\n\n  .with-text {\n    margin-top: 15px;\n    margin-bottom: 10px;\n    font-size: 16px;\n    line-height: 155%;\n  }\n\n  .hero-section-para {\n    font-size: 18px;\n    line-height: 155%;\n  }\n\n  .book-button {\n    letter-spacing: 0;\n    width: 80%;\n    font-family: Inter, sans-serif;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 30px;\n  }\n\n  .sold-out {\n    margin-top: 1.5rem;\n    width: 100%;\n    text-align: center;\n  }\n\n  .percentage-label {\n    font-size: 18px;\n  }\n\n  .percentage-label span {\n    color: black;\n    font-weight: 800;\n  }\n\n  .border-gradient:after {\n    left: 10%;\n    display: none;\n    width: 160%;\n  }\n\n  .border-gradient:before {\n    left: 10%;\n    display: none;\n    width: 160%;\n  }\n\n  .border-gradient-text {\n    font-size: 16px;\n    line-height: 100%;\n  }\n\n  .numbers-section {\n    height: auto;\n    padding-top: 5rem;\n    padding-bottom: 6rem;\n    padding-right: 2rem;\n    padding-left: 2rem;\n  }\n\n  .numbers-section-content h2 {\n    width: 80%;\n    text-align: center;\n    font-size: 30px;\n    font-weight: 700;\n    margin-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n    margin-bottom: 10px;\n  }\n\n  .numbers-section-content {\n    flex-direction: column;\n  }\n\n  .numbers-section-card-container {\n    display: grid;\n    grid-template-columns: 1fr 120px;\n    grid-template-rows: 1fr 0.5fr;\n  }\n\n  .numbers-section-card {\n    width: auto;\n  }\n\n  .numbers-section-card h4 {\n    font-weight: 800 !important;\n    font-size: medium;\n    width: 100%;\n  }\n\n  .numbers-section-card p {\n    font-weight: 700;\n    font-size: small;\n  }\n\n  .reviews-section {\n    text-align: center;\n  }\n\n  .review {\n    width: 100%;\n  }\n\n  .slick-dots {\n    right: 0 !important;\n    bottom: -50px !important;\n  }\n\n  .slick-dots li {\n    margin: 0 2px;\n  }\n\n  .section-heading-pr-2 {\n    font-size: 18px;\n  }\n\n  .section-heading-text {\n    line-height: 40px;\n    font-size: 32px;\n  }\n\n  .money-grid {\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n  }\n\n  .masterclass-for-grid {\n    flex-direction: column;\n  }\n\n  .learning_card {\n    flex-direction: column;\n    gap: 56px;\n  }\n\n  .learn-card-wrapper {\n    grid-column-gap: 0px;\n    grid-row-gap: 56px;\n  }\n\n  .learning_card-image-wrapper {\n    width: 100%;\n    height: 100%;\n  }\n\n  .learning_card-content-wrapper {\n    width: 100%;\n    max-width: 300px;\n    height: 100%;\n  }\n\n  .learning_card-heading {\n    font-size: 15px;\n    line-height: 20px;\n  }\n\n  .featured-on-container {\n    width: 100%;\n  }\n\n  .featured_on_img {\n    margin-right: 2rem;\n    width: 5rem;\n  }\n\n  .faq-list-item {\n    border-radius: 10px;\n    background-color: #ebf1ff;\n    text-align: left;\n    max-height: 6rem;\n    overflow: hidden;\n    transition: max-height 0.5s ease;\n  }\n\n  .faq-list-item-height {\n    max-height: 30rem !important;\n    transition: max-height 0.5s ease;\n  }\n\n  .faq-question-wrapper {\n    grid-column-gap: 0;\n    grid-row-gap: 0;\n    cursor: pointer;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 32px !important;\n    padding: 16px 20px 10px;\n    display: flex;\n  }\n\n  .faq-question-wrapper h3 {\n    flex: 0 100%;\n    margin-bottom: 8px;\n    margin-left: 0;\n    padding-right: 20px;\n    padding-bottom: 20px;\n    font-family: Poppins, sans-serif;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 160%;\n  }\n\n  .faq-list-item-answer {\n    padding: 0 20px;\n    font-size: 14px;\n    line-height: 120%;\n  }\n\n  .masterclass_payment_container {\n    margin-top: 3rem;\n  }\n}\n\n/* Masterclass Payment */\n\n.payment_heading {\n  text-align: center;\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  margin-bottom: 1rem;\n}\n\n.go_back {\n  position: absolute;\n  left: 3%;\n  top: 0%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  background: none;\n}\n\n.go_back p {\n  margin-bottom: 3px !important;\n}\n\n.price_container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.price_wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.price_wrapper span {\n  font-weight: 400 !important;\n  color: black !important;\n}\n\n.price_wrapper:nth-child(3) {\n  margin-top: 1rem;\n  border-top: #000 solid 1px;\n  padding-top: 0.5rem;\n}\n\n.price_wrapper:nth-child(3) span {\n  font-weight: 700 !important;\n}\n\n@media screen and (max-width: 475px) {\n  .go_back {\n    top: -6%;\n    left: 1%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
